<template>
    <div class="flex flex-row gap-5">
        <Button v-if="withBackButton" label="Grįžti atgal" size="small" class="self-start" @click="$router.go(-1)" />
        <div class="text-xl font-medium mb-5">
            {{ title }}
        </div>
    </div>
</template>
<script setup lang="ts">
    import Button from 'primevue/button';

    defineProps({
        title: String,
        withBackButton: Boolean
    })
</script>